export interface NewsItem {
  id: string;
  title: string;
  date: string;
  tag: string;
  isNew: boolean;
}

export interface UpdateItem {
  id: string;
  title: string;
  date: string;
  description: string;
  isNew: boolean;
}

// 本番環境用：データはSupabaseデータベースから取得します
export const mockNews: NewsItem[] = [];
export const mockUpdates: UpdateItem[] = [];
